import React from 'react';
import { makeStyles,Typography,List,ListItem,ListItemAvatar,Tooltip,Avatar,ListItemText,ListItemSecondaryAction,IconButton } from '@material-ui/core';
import { useSelector,useDispatch } from 'react-redux';
import {getLoggRepportV2} from 'actions'
import {isEmpty} from 'lodash'
import moment from 'moment-timezone'
import IntlMessages from 'util/IntlMessages';
import UtkastNy from './InputNy/Utkast' 
import AvbrytaNy from './InputNy/Avbryta'
import StartNy from './InputNy/Start' 
import SkickadNy from './InputNy/Skickad' 

const useStyles = makeStyles((theme) => ({
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(1, 0, 1),
    },
}));
function RapportLogg(props) {
    const dispatch = useDispatch()
    const classes = useStyles()
    const LoggRapportV2 = useSelector(state=>state.accountsData.LoggRapportV2)
    const Userlista = useSelector(state=>state.accountsData.Userlista)
    const authUser = useSelector(state=>state.auth.authUser)
    
    React.useEffect(() => {
        console.log(`initializing interval`);
        dispatch(getLoggRepportV2(authUser.user_id,authUser.user_Afid))
        const interval = setInterval(() => {
           // dispatch(getLoggRepportV2(authUser.user_id,authUser.user_Afid))
        }, 5000);
      
        return () => {
          console.log(`clearing interval`);
          clearInterval(interval);
        };
      }, []);
    const GetStatus=(status)=>{
        switch(status){
            case "Skickad": return <SkickadNy/>
            case "Skapad": return <StartNy/>
            case "Utkast": return <UtkastNy/>
            case "Avbruten": return <AvbrytaNy/>
            default:return <UtkastNy/>
        }
    }
    return (
        <div style={{padding: "0px 20px"}}> 
        <Typography variant="h6" className={classes.title}><u><IntlMessages id="Table.log" /></u></Typography>
        <div className={classes.demo}>
        <List dense={true} className='border-bottom' style={{height:440,overflowY:"auto"}}>
                {LoggRapportV2.map((item,index)=>{
                    let userName= Userlista.find(item1 =>parseInt(item.userid) === parseInt(item1.id))
                    console.log(userName)
                    return (
                        <Tooltip title={
                            <>
                            <p><IntlMessages id="Label.Create.Of"/>: {`${userName.FirstName} ${isEmpty(userName.LastName) ? "" : userName.LastName}`}</p>
                            <p><IntlMessages id="Created"/>:{moment.utc(item.sdate).format("YYYY-MM-DD HH:mm:ss")}</p>
                            <p><IntlMessages id="Label.Report.Name"/>: {item.RapportName}</p>
                            <p>{item.Logg}</p>
                            <p><IntlMessages id="Status.Label1"/> {item.status}</p>
                            </>
                        }>
                    <ListItem style={{background:index%2 === 0?"#eaeaea":"#FFFFFF"}}>
                        <ListItemAvatar>
                            <Avatar style={{ fontSize: '12px' }} className="bg-primary text-white size-30" src={userName.ProfilePicUrl}>{`${userName.FirstName[0]}${isEmpty(userName.LastName)?"":userName.LastName[0]}`}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={item.Logg}
                        />
                        <ListItemSecondaryAction>
                        {GetStatus(item.status)}
                        </ListItemSecondaryAction>
                    </ListItem>
                    </Tooltip>
                    )
                })
                }
             </List>
        </div>
        </div>
    );
}

export default RapportLogg;